// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1M5gQ","footer":"ModalInfo_footer__2Xn4l"};